var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpotOnIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00014 0.818359C4.4761 0.818359 0.818359 4.37986 0.818359 9.00018C0.818359 13.6397 4.4761 17.182 9.00014 17.182C13.5242 17.182 17.1819 13.6205 17.1819 9.00018C17.2012 4.37986 13.5242 0.818359 9.00014 0.818359ZM9.00014 12.9467C6.82475 12.9467 5.07289 11.2333 5.07289 9.01943C5.07289 6.78627 6.82475 5.09216 9.00014 5.09216C11.1755 5.0729 12.9466 6.78627 12.9466 9.00018C12.9466 11.2333 11.1755 12.9467 9.00014 12.9467Z",
    fill: "#0A091B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpotOnIcon);
export default __webpack_public_path__ + "static/media/SpotOnIcon.0601de544c0e2dc416620abbe856c061.svg";
export { ForwardRef as ReactComponent };